// extracted by mini-css-extract-plugin
export var content = "OwnerToast-module_content__DQrhh";
export var button = "OwnerToast-module_button__kLHYc";
export var text = "OwnerToast-module_text__3D0QQ";